import { render, staticRenderFns } from "./PartnerDocumentDropoffForm.vue?vue&type=template&id=66d6fa16"
import script from "./PartnerDocumentDropoffForm.vue?vue&type=script&lang=js"
export * from "./PartnerDocumentDropoffForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports